import VehicleSlider from '~/components/flp/Marketing/VehicleSlider';
import Section from '~/components/flp/Section';
import { ANALYTICS_EVENTS } from '~/constants/flp/analyticsEvents';
import {
  Body,
  Container,
  Content,
  Description,
  Heading,
  Slider,
  Step,
  StepBorder,
  StepIndicator,
  StepNumber,
  Title,
  UnlockRealPaymentsSection
} from './UnlockRealPayments.styles';
import UnlockRealPaymentsCta from './UnlockRealPaymentsCta';

const steps = [
  {
    title: 'Get pre-qualified',
    description: (
      <>
        Answer a few simple questions and in{' '}
        <strong>less than 2 minutes</strong> you’re pre-qualified! No hit to
        your credit.
      </>
    )
  },
  {
    title: 'Browse over 30,000 vehicles',
    description:
      'Shop with real monthly and down payments to find the perfect fit for your budget.'
  },
  {
    title: 'Buy online, get it delivered',
    description:
      'We offer home delivery, or you can pick up your vehicle at a Car Vending Machine near you.'
  }
];

export default function UnlockRealPayments() {
  return (
    <Section
      as={UnlockRealPaymentsSection}
      eventName={ANALYTICS_EVENTS.MARKETING.SECTION_VIEWED_UNLOCKREALPAYMENTS}
    >
      <Container>
        <Heading>Unlock real payments that fit your budget</Heading>
        <Slider>
          <VehicleSlider />
        </Slider>
        <Content>
          <div>
            {steps.map(({ title, description }, index) => (
              <Step key={title}>
                <StepIndicator>
                  {index < steps.length - 1 && <StepBorder />}
                  <StepNumber>{(index + 1).toLocaleString()}</StepNumber>
                </StepIndicator>
                <Body>
                  <Title>{title}</Title>
                  <Description>{description}</Description>
                </Body>
              </Step>
            ))}
          </div>
          <UnlockRealPaymentsCta />
        </Content>
      </Container>
    </Section>
  );
}
